import MemberList from "@/components/members/MemberList.vue";

const memberRoutes = [
  { path: "/members", name: "members", component: MemberList },
];

export default memberRoutes;
